<div [ngClass]="{'d-flex flex-wrap': (!inPopover || (inPopover && !(breakpointService.isTabletDown$ | async)))}">
  <div *ngFor="let tag of tags" class="tag-wrapper" [ngClass]="{'ingredient': isIngredientTag}">
    <button *ngIf="renderInButton" class="btn btn-tag no-padding" (click)="handleTagClicked(tag.name)"
            [attr.aria-label]="'component.tags.tag_aria_label' | translate: { tagName: tag.displayName || tag.name }">
      <ng-container [ngTemplateOutlet]="tagTemplate" [ngTemplateOutletContext]="{ tag: tag }"></ng-container>
    </button>
  
    <span *ngIf="!renderInButton">
      <ng-container [ngTemplateOutlet]="tagTemplate" [ngTemplateOutletContext]="{ tag: tag }"></ng-container>
    </span>
  </div>
</div>

<ng-template #tagTemplate let-tag="tag">
  <span class="tag font-size"
        title="{{tag.displayName || tag.name}}"
        [ngClass]="{'badge': !usesAbbreviations, 'rounded-tag fw-700': usesAbbreviations, 'ingredient': isIngredientTag}"
        [ngStyle]="{'color': tag.textColor || theme.secondaryTextColor, 'background-color': tag.backgroundColor || theme.secondaryBackgroundColor}">
    {{tag.abbreviation || (usesAbbreviations ? ((tag.displayName || tag.name) | abbreviation) : (tag.displayName || tag.name))}}
  </span>
</ng-template>
